<template>
  <request-form
    :model="request"
    @submit="submit"
    @favouriteAdded="updateFavourites"
    @favouriteRemoved="updateFavourites"
  ></request-form>
</template>
<script>
import RequestForm from "../form/RequestForm.vue";
import gql from "graphql-tag";
import moment from "moment";

export default {
  components: { RequestForm },
  apollo: {
    me: {
      query: gql`
        query Me {
          me {
            id
            group {
              id
            }
          }
        }
      `
    }
  },
  data() {
    return {
      request: {
        title: null,
        vacancyID: null,
        companyID: null,
        companyContactPartnerID: null,
        consultantID: null,
        userID: null,
        userGroupID: null,
        startsOn: null,
        duration: null,
        language: null,
        query: {
          fields: [],
          fieldGroups: []
        },
        vacancyTemplate: {
          occupationId: null,
          occupationString: null,
          takeOverOption: null,
          hoursPerWeek: null,
          salary: null,
          workTimes: null
        },
        category: null
      },
      favourites: [],
      favouritesAddresses: []
    };
  },
  methods: {
    updateFavourites(data) {
      this.favourites = data.newFavourites;
    },
    submit(model) {
      model = JSON.parse(JSON.stringify(model));
      delete model["favourites"];
      delete model["favouritesAddresses"];
      const variables = {
        input: model
      };
      this.$apollo
        .mutate({
          mutation: gql`
            mutation($input: MatcherRequestInput!) {
              saveMatcherRequest(input: $input) {
                id
                vacancyID
                title
                startsOn
                duration
                consultantID
                companyID
                company {
                  id
                  addresses {
                    street
                    country
                    zip
                    city
                  }
                }
                vacancyTemplate {
                  occupationId
                  takeOverOption
                  holidayAndChristmasBonus
                  salary
                  hoursPerWeek
                  workTimes
                }
                category
              }
            }
          `,
          variables
        })
        .then(async data => {
          let request = data.data.saveMatcherRequest;
          let vacancyId = request.vacancyID;
          let vacancy = vacancyId
            ? await this.$apollo
                .query({
                  query: gql`
              query Vacancy{
                vacancy(id:"${vacancyId}"){
                  salaryFrame
                  title
                  workPlace
                  recruitment
                  internalInfo
                  occupationCategory{
                    id
                  }
                  jobActivitiesText
                  jobProfilesText
                  jobPerspectiveText
                  jobInfosText
                  jobCustomerDetailsText
                  jobFooterText
                  companyProfileText
                  companyProfileHeading
                  jobActivitiesHeading
                  jobProfilesHeading
                  jobPerspectiveHeading
                  jobInfosHeading
                  jobCustomerDetailsHeading
                  jobFooterHeading
                  topjob
                  topjobDate
                  holidayAndChristmasBonus
                  additionalServices
                  jobEarningLegacy
                  takeoverOption
                  jobHoursLegacy
                  jobTimes{
                    id
                  }
                  jobVariant
                  applicantPoliteSalutation
                  vamTitle
                  vamJobOfferType
                  vamEducationAuthorization
                  vamSocialInsurance
                  companyLogoID
                  samPostID
                  jobTemplateID
                }
              }
            `
                })
                .then(data => data.data.vacancy)
            : {};

          vacancy.title = request.title;

          const template = request.vacancyTemplate;

          vacancy.holidayAndChristmasBonus =
            template.holidayAndChristmasBonus !== null
              ? template.holidayAndChristmasBonus
              : vacancy.holidayAndChristmasBonus;

          vacancy.salaryFrame = template.salary || vacancy.salaryFrame;
          vacancy.occupationCategory =
            template.occupationId ||
            (vacancy.occoupationCategory
              ? vacancy.occoupationCategory.id
              : null);

          vacancy.jobEarningLegacy = vacancy.salaryFrame =
            template.salary || vacancy.jobEarningLegacy;
          vacancy.jobHoursLegacy =
            template.hoursPerWeek || vacancy.jobHoursLegacy;
          vacancy.takeoverOption =
            template.takeOverOption || vacancy.takeoverOption;
          vacancy.activeFrom =
            moment().format("YYYY-MM-DD[T]HH:mm:ss.SSSSSSSSS") + "Z";

          if (request.duration) {
            vacancy.internalInfo += "\n\nDauer:" + request.duration;
          }

          if (request.company.addresses && request.company.addresses.length) {
            vacancy.address = request.company.addresses[0];
            vacancy.address.country = 36;
          }

          vacancy.jobTimes =
            template.workTimes ||
            (vacancy.jobTimes ? vacancy.jobTimes.id : null);

          let project = {
            title: request.title,
            projectState: "INACTIVE",
            company: request.companyID,
            consultantID: request.consultantID,
            userGroup: this.me.group.id,
            contractDate: request.startsOn,
            vacancies: [Object.prepareGqlInput(vacancy)]
          };
          if (request.category === "SAM") {
            project.skillJobTypeID = "5829d43e-aed6-4cca-b7be-5c9ff6a75fe3";
          }
          const projectData = await this.$apollo.mutate({
            mutation: gql`
              mutation($input: CreateVacancyProjectInput!) {
                vacancyProjectCreate(input: $input) {
                  id
                  vacancies {
                    id
                  }
                }
              }
            `,
            variables: {
              input: project
            }
          });

          this.$apollo.mutate({
            mutation: gql`
              mutation($input: MatcherRequestInput!, $id: ID!) {
                updateMatcherRequest(input: $input, id: $id) {
                  id
                }
              }
            `,
            variables: {
              input: Object.assign(variables.input, {
                createdVacancyID:
                  projectData.data.vacancyProjectCreate.vacancies[0].id
              }),
              id: request.id
            }
          });

          for (const favourite of this.favourites) {
            console.log("here");
            const variables = {
              applicant: favourite.id,
              request: request.id
            };
            this.$apollo.mutate({
              mutation: gql`
                mutation addApplicantToFavourites(
                  $request: ID!
                  $applicant: ID!
                ) {
                  addApplicantToFavourites(
                    request: $request
                    applicant: $applicant
                  ) {
                    id
                  }
                }
              `,
              variables
            });
          }

          this.$router.push({
            name: "project.edit.sub",
            params: {
              id: projectData.data.vacancyProjectCreate.id,
              page: "jobs"
            }
          });
        });
    }
  }
};
</script>
